import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { formatPrice } from 'Utils';
import Button from 'Components/Button';
import Accordion from 'Components/Accordion';
import Price from 'Components/Price';
import { Container, Row, Col } from 'Components/Grid';
import cn from 'classnames';
import styles from './styles.scss';
import ConsumptionData from 'Components/ConsumptionData';

export default class ServiceBox extends React.Component {
  static propTypes = {
    headline: PropTypes.string,
    description: PropTypes.string,
    scopes: PropTypes.array,
    benefits: PropTypes.array,
    price: PropTypes.number,
    priceText: PropTypes.string,
    priceType: PropTypes.string,
    onContactClick: PropTypes.func,
    footnote: PropTypes.object,
    withLegalForReifenservice: PropTypes.bool,
    consumptionText: PropTypes.string,
    buttonLabel: PropTypes.string,
    trackingLabel: PropTypes.string,
  };

  render() {
    const {
      headline,
      description,
      scopes,
      benefits,
      price,
      priceText,
      priceType,
      onContactClick,
      footnote,
      withLegalForReifenservice,
      consumptionText,
      buttonLabel,
      trackingLabel,
    } = this.props;

    return (
      <div className={styles.root}>
        <Container>
          <h2 className={styles.headline}>{headline}</h2>
          <div className={styles.description} dangerouslySetInnerHTML={{ __html: description }} />

          {withLegalForReifenservice ? (
            <div
              className={cn(
                styles.legalWrapper,
                (scopes.length > 0 || benefits.length > 0) && styles.legalWrapperMarginBottom
              )}
            >
              <strong>DAS EU-REI­FEN­LA­BEL GÜLTIG AB 1. MAI 2021</strong>

              <p>
                Damit Autofahrer fundiertere Entscheidungen beim Reifenkauf treffen können, hat die
                EU zum 1. Mai 2021 ein neues Reifenlabel eingeführt. Ziel der neuen
                Reifenkennzeichnung ist es, sowohl die Sicherheit als auch die Umweltverträglichkeit
                im Straßenverkehr zu verbessern und gleichzeitig CO2-Emissionen zu reduzieren.
                Informationen über die verfügbaren Reifen für Ihren Mazda sowie zu den verschiedenen
                Qualitätskriterien helfen Ihnen bei Ihrer Auswahl.{' '}
                <a
                  href="https://www.mazda.de/eu-reifenlabel/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Mehr erfahren
                </a>
              </p>
            </div>
          ) : null}

          <Row className={styles.accordions}>
            <Col cols={12} m={6}>
              {scopes.length > 0 && (
                <Accordion label="Leistungsumfang" collapsible={'m'}>
                  <ul className={styles.list}>
                    {scopes.map((scope) => {
                      return <li key={`scope-${scope.id}}`}>{scope.name}</li>;
                    })}
                  </ul>
                </Accordion>
              )}
            </Col>
            <Col cols={12} m={6}>
              {benefits.length > 0 && (
                <Accordion label="Vorteile" collapsible={'m'}>
                  <ul className={styles.list}>
                    {benefits.map((benefit) => {
                      return <li key={`benefit-${benefit.id}}`}>{benefit.name}</li>;
                    })}
                  </ul>
                </Accordion>
              )}
            </Col>
          </Row>
          <div className={styles.footer}>
            <div className={styles.price}>
              {priceType !== 'NONE' && (
                <Fragment>
                  <Price value={formatPrice(price)} prefix={priceType} />
                  {(priceText || footnote) && (
                    <h5>
                      {priceText}
                      {footnote && <sup>{footnote.number}</sup>}
                    </h5>
                  )}
                </Fragment>
              )}
            </div>
            <div className={styles.cta}>
              <Button
                type="secondary"
                label={buttonLabel}
                onClick={onContactClick}
                trackingLabel={trackingLabel}
              />
            </div>
          </div>
        </Container>

        <ConsumptionData consumptionText={[consumptionText]} style={{ marginTop: '30px' }} />
      </div>
    );
  }
}
